import { render, staticRenderFns } from "./TotalSpend.vue?vue&type=template&id=6a7b68f2&scoped=true&"
import script from "./TotalSpend.vue?vue&type=script&lang=js&"
export * from "./TotalSpend.vue?vue&type=script&lang=js&"
import style0 from "./TotalSpend.vue?vue&type=style&index=0&id=6a7b68f2&lang=scss&scoped=true&"
import style1 from "./TotalSpend.vue?vue&type=style&index=1&id=6a7b68f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b68f2",
  null
  
)

export default component.exports